/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function SubjectField (props: FormTextFieldProps) {
  const { name = 'subject', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'subject',
        defaultMessage: 'Sujet'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default SubjectField
